import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'LD',
  quote: 'Hice mis primeros trabajos y ya tengo tres clientes del barrio',
  name: 'Lucas D.',
  location: 'Lanús'
}, {
  initials: 'DS',
  quote: 'Es como tener un técnico al lado explicándote todo',
  name: 'Diego S.',
  location: 'Mar del Plata'
}];
export function ShortTestimonials() {
  return <section className="py-16 px-4 bg-brand-gray" data-id="element-258">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-259">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center text-center" data-id="element-260">
            <div className="w-16 h-16 bg-brand-primary text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-261">
              {t.initials}
            </div>
            <div className="flex text-brand-amber mb-4" data-id="element-262">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-263" />)}
            </div>
            <p className="text-xl font-bold text-gray-800 mb-4 italic" data-id="element-264">
              "{t.quote}"
            </p>
            <p className="text-base text-gray-500 font-medium" data-id="element-265">
              — {t.name}, {t.location}
            </p>
          </div>)}
      </div>
    </section>;
}